import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./homePage";
import TestimonialsPage from "./testimonialsPage";
import ContactUsPage from "./contactPage";
import ChooseUsPage from "./chooseUsPage";
import AboutUsPage from "./aboutUsPage";
import ConsultingPage from "./consultingPage";
import CorporateManagementPage from "./corporateManagementPage";
import TehnologyManagementPage from "./tehnologyManagementPage";
import CustomSoftwareDevelopmentPage from "./customSoftwareDevelopmentPage";
import ServicesPage from "./servicesPage";

const PageRouter = () => {
  return (
    <div>
      <Routes>
        <Route path="/*" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/our-mission" element={<ChooseUsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/consulting" element={<ConsultingPage />} />
        <Route path="/corporate-management" element={<CorporateManagementPage />} />
        <Route path="/tehnology-management" element={<TehnologyManagementPage />} />
        <Route path="/software-development" element={<CustomSoftwareDevelopmentPage />} />
        <Route path="/services" element={<ServicesPage />} />
      </Routes>
    </div>
  );
};

export default PageRouter;
